(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ales-lineup-selector"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ales-lineup-selector')) {
  customElements.define('ales-lineup-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const labels = JSON.parse(this.querySelector('[data-alc-labels]').textContent);
      const cards = [...this.querySelectorAll('.alc-card')];
      const buttons = [...this.querySelectorAll('[data-alc-filter]')];
      const update = (filter) => {
        let count = 0;
        cards.forEach(card => {
          card.hidden = filter !== 'all' && card.getAttribute('data-alc-' + filter) !== 'true';
          if (!card.hidden) count++;
        });
        buttons.forEach(button => {
          const selected = button.dataset.alcFilter === filter;
          button.setAttribute('aria-pressed', String(selected));
        });
        this.querySelector('[data-alc-result]').textContent = labels[filter];
        this.querySelector('[data-alc-count]').textContent = count + labels.count;
        this.querySelector('.alc-empty').hidden = count !== 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => update(button.dataset.alcFilter), { signal: this.abort.signal }));
      update('all');
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ales-pop-image-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ales-line-campaign')) {
    class AlesLineCampaign extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('.alc-dialog');
        this.badgeWrap = this.querySelector('.alc-badge-wrap');
        this.badge = this.querySelector('.alc-badge');
        this.closeButton = this.querySelector('.alc-close');
        this.inEditor = Boolean(window.Shopify && Shopify.designMode);
        this.isDraft = Boolean(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');
        this.preview = this.isDraft && new URLSearchParams(location.search).get('line_preview') === '1';
        const scope = this.isDraft ? `draft-${Shopify.theme.id}-` : '';
        this.storageKey = `AlesLineCampaignNextAt-${scope}${this.dataset.campaign}`;
        this.dismissKey = `${this.storageKey}-hidden`;
        this.remaining = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
        this.snooze = Math.max(0, Number(this.dataset.snoozeHours) || 0) * 3600000;
        this.nextAt = this.readNextAt();
        this.dismissed = !this.preview && this.readStorage('sessionStorage', this.dismissKey) === '1';
        this.seen = this.nextAt > Date.now();
        this.badgeEligible = this.seen;
        this.started = false;
        this.previousVisible = !document.hidden;
        this.lastTick = performance.now();
        this.dataset.state = 'waiting';
        this.querySelectorAll('.alc-close,.alc-skip').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
        this.badge.addEventListener('click', () => this.open('manual'), { signal });
        this.querySelector('.alc-badge-close').addEventListener('click', () => {
          this.dismissed = true;
          this.writeStorage('sessionStorage', this.dismissKey, '1');
          this.badgeWrap.hidden = true;
          this.dataset.state = 'hidden';
          this.emit('dismiss');
        }, { signal });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = [...this.dialog.querySelectorAll('button:not([disabled]),a[href]')].filter(element => element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('alc-scroll-locked');
          this.badgeEligible = true;
          this.updateBadge();
        }, { signal });
        this.querySelector('.alc-cta').addEventListener('click', () => { this.emit('line_click'); this.close(); }, { signal });
        document.addEventListener('visibilitychange', () => { this.tick(); }, { signal });
        window.addEventListener('ales:loader:hidden', () => this.tick(), { signal });
        window.addEventListener('pageshow', () => this.tick(), { signal });
        window.addEventListener('pagehide', () => { if (this.dialog.open) this.dialog.close(); }, { signal });
        window.addEventListener('storage', event => {
          if (event.key === this.storageKey) {
            this.nextAt = this.readNextAt();
            this.seen = this.seen || this.nextAt > Date.now();
            this.badgeEligible = this.badgeEligible || this.seen;
            this.updateBadge();
          }
        }, { signal });
        if (this.inEditor) {
          document.addEventListener('shopify:section:select', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open('editor');
          }, { signal });
          document.addEventListener('shopify:section:deselect', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.close();
          }, { signal });
        }
        this.observer = new MutationObserver(mutations => {
          if (mutations.every(m => this.contains(m.target))) return;
          this.updateBadge();
        });
        this.observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
        this.timer = setInterval(() => this.tick(), 200);
        this.tick();
      }
      readStorage(type, key) { try { return window[type].getItem(key); } catch (_) { return null; } }
      writeStorage(type, key, value) { if (this.preview || this.inEditor) return; try { window[type].setItem(key, value); } catch (_) {} }
      readNextAt() {
        if (this.preview || this.inEditor) return 0;
        const values = [this.readStorage('localStorage', this.storageKey), this.readStorage('sessionStorage', this.storageKey)];
        if (!this.isDraft) {
          values.push(this.readStorage('localStorage', this.dataset.legacyKey));
          try {
            for (let i = 0; i < localStorage.length; i++) {
              const key = localStorage.key(i);
              if (key.startsWith('AlesPopImagePopupNextAt-') && key.endsWith(`-${this.dataset.campaign}`)) values.push(localStorage.getItem(key));
            }
          } catch (_) {}
        }
        return Math.max(0, ...values.map(value => Number(value) || 0));
      }
      loaderVisible() {
        const loader = document.getElementById('AlesBrandLoader');
        return document.documentElement.classList.contains('ales-loader-active') || Boolean(loader && !loader.hidden && loader.getAttribute('aria-hidden') !== 'true');
      }
      busy() {
        return Boolean(document.querySelector('header details[open],header-drawer details[open],details-modal details[open],cart-drawer.active,.cart-notification.active,dialog[open]:not(.alc-dialog)'));
      }
      updateBadge() {
        if (!this.badgeWrap) return;
        this.badgeWrap.hidden = !this.badgeEligible || this.dismissed || this.dialog.open || this.loaderVisible() || this.busy();
        if (!this.dialog.open && this.badgeEligible) this.dataset.state = this.dismissed ? 'hidden' : 'badge';
      }
      tick() {
        const now = performance.now();
        const visible = !document.hidden;
        const loader = this.loaderVisible();
        if (!this.started && !loader) {
          this.started = true;
          this.dataset.readyAt = String(Math.round(now));
          this.lastTick = now;
        }
        if (this.started && !loader && visible && this.previousVisible) this.remaining -= Math.max(0, now - this.lastTick);
        this.lastTick = now;
        this.previousVisible = visible;
        this.updateBadge();
        if (!this.started || loader || !visible || this.dialog.open) return;
        if (this.seen || this.dismissed) { clearInterval(this.timer); return; }
        if (this.remaining > 0 || this.busy()) return;
        this.open('automatic');
      }
      open(source) {
        if (this.dialog.open || this.loaderVisible() || (source !== 'editor' && this.busy())) return;
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('alc-scroll-locked');
        this.badgeWrap.hidden = true;
        this.seen = true;
        this.badgeEligible = true;
        this.dataset.state = 'open';
        this.dataset.openedAt = String(Math.round(performance.now()));
        this.dataset.openSource = source;
        clearInterval(this.timer);
        const nextAt = Date.now() + this.snooze;
        this.nextAt = nextAt;
        this.writeStorage('localStorage', this.storageKey, String(nextAt));
        this.writeStorage('sessionStorage', this.storageKey, String(nextAt));
        if (!this.isDraft) this.writeStorage('localStorage', this.dataset.legacyKey, String(nextAt));
        this.closeButton.focus({ preventScroll: true });
        this.emit('view', source);
      }
      close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        document.documentElement.classList.remove('alc-scroll-locked');
        this.updateBadge();
        const previous = this.returnFocus;
        if (previous && previous !== document.body && previous !== document.documentElement && previous.isConnected && previous.getClientRects().length) previous.focus({ preventScroll: true });
        else if (!this.badgeWrap.hidden) this.badge.focus({ preventScroll: true });
        this.emit('close');
      }
      emit(action, source) {
        if (this.preview || this.inEditor) return;
        this.dispatchEvent(new CustomEvent('ales:line-campaign', { bubbles: true, detail: { action, source: source || this.dataset.openSource || 'manual', campaign: this.dataset.campaign, draft: this.isDraft } }));
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('alc-scroll-locked');
        this.controller = null;
      }
    }
    customElements.define('ales-line-campaign', AlesLineCampaign);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
